import { CloseButton, SaveOverlay, ShortcutProvider } from "@itk/mui-components";
import { hasValue } from "@itk/typescript-utils";
import { Dialog, DialogActions, DialogContent, Stack } from "@mui/material";
import { useEffect } from "react";
import { DocumentViewer } from "./document-viewer";
import { FileModelState } from "../application-types";

export const DocumentViewerDialog = (props: { fileInfo: FileModelState; resetFile: () => void }) => {
  const { fileInfo, resetFile } = props;
  useEffect(() => {
    if (hasValue(fileInfo.fileId) && !fileInfo.previewAvailable) {
      resetFile();
    }
  }, [fileInfo.fileId, fileInfo.previewAvailable]);

  if (!hasValue(fileInfo.fileId) || !fileInfo.previewAvailable) return null;

  return (
    <ShortcutProvider>
      <Dialog open fullWidth maxWidth="lg" onClose={resetFile}>
        <DialogContent sx={{ height: "95vh" }}>
          <Stack display="flex" flexDirection="column" height="100%">
            <DocumentViewer fileId={fileInfo.fileId} />
          </Stack>
        </DialogContent>
        <DialogActions>
          <CloseButton onClose={resetFile} />
        </DialogActions>
        <SaveOverlay />
      </Dialog>
    </ShortcutProvider>
  );
};
